module.exports = __webpack_public_path__ + "static/img/icon-contest-flow.de137935.png";